import { trackMpEvent } from '@/helpers';
import { Tracking } from '@/types/analytics';
import { useEffect } from 'react';

type ScreenShownProperties = Tracking.ScreenShown['properties'];

/**
 * @deprecated: use typed trackMpEvent from helpers/analyticsTs.ts
 */
export function trackScreenShown(event: ScreenShownProperties) {
  trackMpEvent('screen_shown', event);
}

/**
 * @deprecated: use typed trackMpEvent from helpers/analyticsTs.ts
 */
const useTrackScreenShown = (event: ScreenShownProperties, deps: unknown[] = [], conditions: boolean[] = []) => {
  useEffect(() => {
    conditions.every((condition) => condition) && trackScreenShown(event);
  }, deps);
};

export default useTrackScreenShown;
